/**
 * @generated SignedSource<<79146643d3daf789b65ba4f8791b7871>>
 * @relayHash 4c0bb2fb809f8fe19ab2e65961e1b946
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b8db1ac24f103f93985102954aa51bf9c32439d5531ad5932702f7b56f15d4cd

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSidebarMenuItemReorderOperation = "AFTER" | "BEFORE" | "MOVE_DOWN" | "MOVE_TO_BOTTOM" | "MOVE_TO_TOP" | "MOVE_UP" | "%future added value";
export type JiraReorderSidebarMenuItemInput = {
  cloudId: string;
  menuItem: JiraSidebarMenuItemInput;
  relativeMenuItem?: JiraSidebarMenuItemInput | null;
  reorderMode: JiraSidebarMenuItemReorderOperation;
};
export type JiraSidebarMenuItemInput = {
  itemId: string;
};
export type useUpdateFavouriteOrderMutation$variables = {
  input: JiraReorderSidebarMenuItemInput;
};
export type useUpdateFavouriteOrderMutation$data = {
  readonly jira_reorderProjectsSidebarMenuItem: {
    readonly favourites: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly projectKey: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectMenuItem">;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null;
    readonly id: string;
  } | null;
};
export type useUpdateFavouriteOrderMutation = {
  response: useUpdateFavouriteOrderMutation$data;
  variables: useUpdateFavouriteOrderMutation$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider: {
    readonly get: () => boolean;
  };
});

import isActionMenuWithAddPeopleSpotlightIdEnabled_provider from '@jira/platform__graphql-relay-provider/src/JsmEnableActionMenuAddPeopleSpotlightIdRelayProvider';
import isSubspaceEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider';
import checkForA11YEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 15
  }
],
v4 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v5 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateFavouriteOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "Nav4ProjectMenuItem"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useUpdateFavouriteOrderMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProjectsSidebarMenu",
        "kind": "LinkedField",
        "name": "jira_reorderProjectsSidebarMenuItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "large"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "defaultNavigationItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "EDIT_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canPerform"
                          }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "softwareBoardCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "webUrl"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": "subspaceCount",
                                "kind": "ScalarField",
                                "name": "subspaceCount_cse"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ],
            "storageKey": "favourites(first:15)"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b8db1ac24f103f93985102954aa51bf9c32439d5531ad5932702f7b56f15d4cd",
    "metadata": {},
    "name": "useUpdateFavouriteOrderMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJsmEnableActionMenuAddPeopleSpotlightIdRelayProvidertsx": isActionMenuWithAddPeopleSpotlightIdEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider
    }
  }
};
})();

(node as any).hash = "66de2e69da219bee3821eec0cafe8fb9";

export default node;
